/**
 * action type constants defined here should be globally unique.
 */

// user
const SAVE_USER_TOKEN = 'SAVE_USER_TOKEN';
const SAVE_USER_PROFILE = 'SAVE_USER_PROFILE';

const FETCH_USER_PROFILE_REQUEST = 'FETCH_USER_PROFILE_REQUEST';
const FETCH_USER_PROFILE_SUCCESS = 'FETCH_USER_PROFILE_SUCCESS';
const FETCH_USER_PROFILE_FAILURE = 'FETCH_USER_PROFILE_FAILURE';

const USER_LOG_IN = 'USER_LOG_IN';
const USER_LOG_OUT = 'USER_LOG_OUT';

const CHECK_EMAIL_VALIDITY = 'CHECK_EMAIL_VALIDITY';

const user = {
  SAVE_USER_TOKEN,
  SAVE_USER_PROFILE,
  FETCH_USER_PROFILE_REQUEST,
  FETCH_USER_PROFILE_SUCCESS,
  FETCH_USER_PROFILE_FAILURE,
  USER_LOG_IN,
  USER_LOG_OUT,
  CHECK_EMAIL_VALIDITY
};

// license
const LICENSE_TYPE_JWT = 'jwt';

const FETCH_LICENSE_REQUEST = 'FETCH_LICENSE_REQUEST';
const FETCH_LICENSE_SUCCESS = 'FETCH_LICENSE_SUCCESS';
const FETCH_LICENSE_FAILED = 'FETCH_LICENSE_FAILED';
const FETCH_LICENSE_STATUS_RESET = 'FETCH_LICENSE_STATUS_RESET';

const CREATE_LICENSE_REQUEST = 'CREATE_LICENSE_REQUEST';
const CREATE_LICENSE_SUCCESS = 'CREATE_LICENSE_SUCCESS';
const CREATE_LICENSE_FAILED = 'CREATE_LICENSE_FAILED';
const CREATE_LICENSE_STATUS_RESET = 'CREATE_LICENSE_STATUS_RESET';

const APPROVE_LICENSE_REQUEST = 'APPROVE_LICENSE_REQUEST';
const APPROVE_LICENSE_SUCCESS = 'APPROVE_LICENSE_SUCCESS';
const APPROVE_LICENSE_FAILED = 'APPROVE_LICENSE_FAILED';
const APPROVE_LICENSE_STATUS_RESET = 'APPROVE_LICENSE_STATUS_RESET';

const REJECT_LICENSE_REQUEST = 'REJECT_LICENSE_REQUEST';
const REJECT_LICENSE_SUCCESS = 'REJECT_LICENSE_SUCCESS';
const REJECT_LICENSE_FAILED = 'REJECT_LICENSE_FAILED';
const REJECT_LICENSE_STATUS_RESET = 'REJECT_LICENSE_STATUS_RESET';

const UPLOAD_SEED_REQUEST = 'UPLOAD_SEED_REQUEST';
const UPLOAD_SEED_SUCCESS = 'UPLOAD_SEED_SUCCESS';
const UPLOAD_SEED_FAILED = 'UPLOAD_SEED_FAILED';
const UPLOAD_SEED_STATUS_RESET = 'UPLOAD_SEED_STATUS_RESET';

const FETCH_CONTRACT_REQUEST = 'FETCH_CONTRACT_REQUEST';
const FETCH_CONTRACT_SUCCESS = 'FETCH_CONTRACT_SUCCESS';
const FETCH_CONTRACT_FAILED = 'FETCH_CONTRACT_FAILED';
const FETCH_CONTRACT_STATUS_RESET = 'FETCH_CONTRACT_STATUS_RESET';

const UPLOAD_CONTRACT_REQUEST = 'UPLOAD_CONTRACT_REQUEST';
const UPLOAD_CONTRACT_SUCCESS = 'UPLOAD_CONTRACT_SUCCESS';
const UPLOAD_CONTRACT_FAILED = 'UPLOAD_CONTRACT_FAILED';
const UPLOAD_CONTRACT_STATUS_RESET = 'UPLOAD_CONTRACT_STATUS_RESET';

const license = {
  FETCH_LICENSE_REQUEST,
  FETCH_LICENSE_SUCCESS,
  FETCH_LICENSE_FAILED,
  FETCH_LICENSE_STATUS_RESET,
  CREATE_LICENSE_REQUEST,
  CREATE_LICENSE_SUCCESS,
  CREATE_LICENSE_FAILED,
  CREATE_LICENSE_STATUS_RESET,
  APPROVE_LICENSE_REQUEST,
  APPROVE_LICENSE_SUCCESS,
  APPROVE_LICENSE_FAILED,
  APPROVE_LICENSE_STATUS_RESET,
  REJECT_LICENSE_REQUEST,
  REJECT_LICENSE_SUCCESS,
  REJECT_LICENSE_FAILED,
  REJECT_LICENSE_STATUS_RESET,
  UPLOAD_SEED_REQUEST,
  UPLOAD_SEED_SUCCESS,
  UPLOAD_SEED_FAILED,
  UPLOAD_SEED_STATUS_RESET,
  FETCH_CONTRACT_REQUEST,
  FETCH_CONTRACT_SUCCESS,
  FETCH_CONTRACT_FAILED,
  FETCH_CONTRACT_STATUS_RESET,
  UPLOAD_CONTRACT_REQUEST,
  UPLOAD_CONTRACT_SUCCESS,
  UPLOAD_CONTRACT_FAILED,
  UPLOAD_CONTRACT_STATUS_RESET
};

const FETCH_USER_LIST_REQUEST = 'FETCH_USER_LIST_REQUEST';
const FETCH_USER_LIST_SUCCESS = 'FETCH_USER_LIST_SUCCESS';
const FETCH_USER_LIST_FAILED = 'FETCH_USER_LIST_FAILED';
const FETCH_USER_LIST_STATUS_RESET = 'FETCH_USER_LIST_STATUS_RESET';

const UPDATE_USER_INFO_REQUEST = 'UPDATE_USER_INFO_REQUEST';
const UPDATE_USER_INFO_SUCCESS = 'UPDATE_USER_INFO_SUCCESS';
const UPDATE_USER_INFO_FAILED = 'UPDATE_USER_INFO_FAILED';
const UPDATE_USER_INFO_STATUS_RESET = 'UPDATE_USER_INFO_STATUS_RESET';

const admin = {
  FETCH_USER_LIST_REQUEST,
  FETCH_USER_LIST_SUCCESS,
  FETCH_USER_LIST_FAILED,
  FETCH_USER_LIST_STATUS_RESET,
  UPDATE_USER_INFO_REQUEST,
  UPDATE_USER_INFO_SUCCESS,
  UPDATE_USER_INFO_FAILED,
  UPDATE_USER_INFO_STATUS_RESET
};

export const notification = {
  FETCH_NOTIFICATION_REQUEST: 'FETCH_NOTIFICATION_REQUEST',
  FETCH_NOTIFICATION_SUCCESS: 'FETCH_NOTIFICATION_SUCCESS',
  FETCH_NOTIFICATION_FAILED: 'FETCH_NOTIFICATION_FAILED',
  FETCH_NOTIFICATION_STATUS_RESET: 'FETCH_NOTIFICATION_STATUS_RESET'
};

export { user, license, admin, LICENSE_TYPE_JWT };
